/**
 * Focus vignette: a slight, steady yellow edge glow shown while focus mode is
 * active. Non-obstructing (transparent centre, `pointer-events: none`), and
 * sits below the red damage vignette so a hit still reads over it. Fades in/out
 * with a CSS transition as focus toggles.
 */
export class FocusVignette {
  private readonly el: HTMLDivElement;

  constructor(parent: HTMLElement) {
    const el = document.createElement('div');
    el.className = 'focus-vignette';
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.pointerEvents = 'none';
    el.style.opacity = '0';
    el.style.zIndex = '29';
    el.style.transition = 'opacity 0.25s ease';
    el.style.background =
      'radial-gradient(ellipse at center, rgba(255,215,0,0) 58%, rgba(210,170,20,0.22) 100%)';
    parent.appendChild(el);
    this.el = el;
  }

  setActive(active: boolean): void {
    this.el.style.opacity = active ? '1' : '0';
  }
}
